// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"./GlobalStyles.css\"","activeColor":"#7cf4fe","screen-min":"639px","screen-sm-max":"1365px","screen-md":"1366px","screen-md-max":"1679px","screen-lg":"1680px"};